<div class="suspend-station-dialog">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.suspend-station-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="dialog-content">
      <mat-form-field class="textarea-note" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.currentPosition.hint"></sc-dictionary-label>
        </mat-label>
        <textarea matInput [maxLength]="255" [rows]="3"
          [(ngModel)]="note" required></textarea>
      </mat-form-field>
    </div>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancelDialog()" [disabled]="false"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="suspendStation()" class="confirm-button"
        [disabled]="isSupendStationDisabled()">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.suspend-station-dialog.action.confirm"></sc-dictionary-label>
      </button>
    </sc-actionbar>
  </div>
</div>
